import { useState } from "react";
import api from "../api/axios";
import Card from "../components/UI/Card";
import Input from "../components/UI/Input";
import Button from "../components/UI/Button";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("otp_email", data.email);
      localStorage.setItem("otp_sent_at", Date.now().toString());
      sessionStorage.setItem("otp_password", password);
      nav("/verify-otp");
    } catch (err) {
      setMsg(err?.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="h-full flex items-center justify-center p-4" style={{ background: "rgb(var(--bg))" }}>
      <div className="w-full max-w-sm">
        {/* Brand */}
        <div className="text-center mb-8">
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-2xl text-white text-2xl font-bold mb-4 shadow-lg"
            style={{ background: "rgb(var(--primary))" }}
          >R</div>
          <div className="text-2xl font-bold tracking-tight">Ramaa Group</div>
          <div className="text-sm opacity-40 mt-1">Admin Portal — Sign in to continue</div>
        </div>

        <Card className="p-7">
          {msg && (
            <div className="mb-4 px-3 py-2.5 rounded-xl bg-red-50 border border-red-200 text-red-600 text-sm">
              {msg}
            </div>
          )}

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wider opacity-50 mb-1.5">Email</label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wider opacity-50 mb-1.5">Password</label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <Button loading={loading} className="w-full mt-2">
              {loading ? "Sending OTP..." : "Send OTP"}
            </Button>
          </form>
        </Card>

        <div className="text-center text-xs opacity-30 mt-6">Ramaa Group &copy; {new Date().getFullYear()}</div>
      </div>
    </div>
  );
}